import React from 'react';
import { ReactComponent } from 'Common/components/Icons/add-task.svg';

const AddTask = () => <ReactComponent className="MuiSvgIcon-root" />;

export default AddTask;
